import { render, staticRenderFns } from "./OrderBasket.vue?vue&type=template&id=5ffbdb7e&scoped=true&"
import script from "./OrderBasket.vue?vue&type=script&lang=js&"
export * from "./OrderBasket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffbdb7e",
  null
  
)

export default component.exports